import { TracktorContext, initialState } from './TracktorContext';
import type { TracktorProviderProps } from './types';

export function TracktorProvider({ children, dispatcher }: TracktorProviderProps) {
	const value = { ...initialState, dispatcher };

	return (
		<TracktorContext.Consumer>
			{(context) => {
				const { dispatcher: contextDispatcher } = context;

				// If `contextDispatcher.isDefault` is falsey, we already have a custom contextDispatcher set.
				// The consumer is only allowed to have one custom contextDispatcher per render tree.
				if (!contextDispatcher.isDefault && process.env.NODE_ENV !== 'production') {
					throw new Error(
						'Only one `<TracktorProvider />` is allowed in the render tree. This would lead to unexpected behaviour otherwise.'
					);
				}

				return <TracktorContext value={value}>{children}</TracktorContext>;
			}}
		</TracktorContext.Consumer>
	);
}
